var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c(`svg-${_vm.name}`,{tag:"component",attrs:{"height":_vm.height,"width":_vm.width,"use-custom-dimensions":_vm.useCustomDimensions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }